export const TEMPLATE_MIXED = "30";
export const TEMPLATE_SLIDER_SQUARE = "46";
export const TEMPLATE_SLIDER_PORTRAIT = "45";
export const TEMPLATE_LIST_LARGE_OVERLAY = "1";
export const TEMPLATE_LIST_LARGE = "7";
export const TEMPLATE_LIST_LARGE_NO_TITLE = "36";
export const TEMPLATE_CAROUSEL_TITLE_BELOW = "43";

export const SLIDER_TEMPLATES = [
  "3",
  "16",
  TEMPLATE_SLIDER_PORTRAIT,
  TEMPLATE_SLIDER_SQUARE,
  "48",
  "49",
];
export const CAROUSEL_TEMPLATES = ["27", TEMPLATE_CAROUSEL_TITLE_BELOW];
export const COURSE_TEMPLATES = ["39"];
export const GRID_TEMPLATES = ["26", "42", "13", "28"];
export const COURSE_VIEW_TEMPLATE = "39";
export const IN_PROGRESS_TEMPLATE = "44";
export const LIST_TEMPLATES = [
  TEMPLATE_LIST_LARGE,
  "10",
  TEMPLATE_LIST_LARGE_NO_TITLE,
  TEMPLATE_LIST_LARGE_OVERLAY,
  "2",
  "12",
];
export const CONTENT_TEMPLATES = [
  ...SLIDER_TEMPLATES,
  ...CAROUSEL_TEMPLATES,
  ...GRID_TEMPLATES,
  ...LIST_TEMPLATES,
];

export const ITEM_TYPE_COLLECTION = "collection";
export const ITEM_TYPE_VIDEO = "video";

export const VIDEO_TYPE_AUDIO = "audio";
export const VIDEO_TYPE_VIDEO = "video";
export const VIDEO_TYPE_POST = "post";

// Circuit Workouts
export const TEMPLATE_WORKOUT = "34";
export const TEMPLATE_CIRCUIT = "35";
export const WORKOUT_TEMPLATES = [TEMPLATE_WORKOUT, TEMPLATE_CIRCUIT];
export const VIDEO_TYPE_REST = "rest";

export const VIDEO_LOCKED = "-1";
export const VIDEO_UNLOCKED = "0";
export const EVENT_TYPE_WATCHED = "watched";
export const EVENT_TYPE_SCHEDULED = "scheduled";
export const EVENT_TYPE_JOURNAL = "journal";

export const PRODUCT_PLATFORM_APPLE = "Apple";
export const PRODUCT_PLATFORM_ANDROID = "Android";
export const PRODUCT_PLATFORM_STRIPE = "Stripe";
export const PRODUCT_PLATFORM_MANUAL = "Manual";

export const BREAKPOINT_0 = 768;
export const BREAKPOINT_1 = 935;
export const BREAKPOINT_2 = 1101;
export const BREAKPOINT_3 = 1281;
export const BREAKPOINT_4 = 1513;
export const BREAKPOINT_5 = 1728;

export const RESUBSCRIBE_BANNER_HEIGHT = 47;

export const GOOGLE_PLAY = "Google Play Store";
export const APPLE_STORE = "Apple App Store";
export const DEFAULT_FAVOURITES_LABEL = "Favorites";
export const DEFAULT_WATCHLIST_LABEL = "Watch Later";
export const DEFAULT_RESOURCES_LABEL = "Resources";
export const DEFAULT_COMMENTS_LABEL = "Comments";
export const DEFAULT_UP_NEXT_LABEL = "Up Next";

export const TEMPLATE_SEARCH = "18";
export const TEMPLATE_CALENDAR = "17";
export const TEMPLATE_PLAYLISTS = "33";
export const TEMPLATE_WEBSITE = "5";
export const TEMPLATE_COMMUNITY = "47";
// Query Params
export const QUERY_PARENT_ID = "parent_id";
export const QUERY_COURSE_ID = "course_id";

export const DRAWER_CALENDAR = "calendar";
export const DRAWER_PLAYLIST = "playlist";
export const DRAWER_COMMENT = "comment";
export const DRAWER_SEARCH = "search";
export const DRAWER_SCHEDULE = "schedule";
export const DRAWER_COMPLETE_PREVIOUSLY = "complete_previously";
export const DRAWER_RESOURCE = "resource";
export const DRAWER_DESCRIPTION = "description";
export const DRAWER_REORDER_PLAYLISTS = "reorder_playlist";
export const DRAWER_BLOCKED_USERS = "blocked_users";
export const DRAWER_NOTIFICATION_SETTINGS = "notification_settings";

export const HOURS_12_IN_MS = 12 * 60 * 60 * 1000;
export const MINUTES_10_IN_MS = 10 * 60 * 1000;
export const HOURS_3_IN_MS = 3 * 60 * 60 * 1000;
